const tickets = {
    namespaced: true,
    state: {
        tickets: [],
        ticket: {
            B2B_FEATURES: {},
            B2B_USER_ID: null,
            COMMENT: "",
            CREATED_AT: "",
            FILE: "",
            ID: null,
            PRIORITY_ID: 2,
            STATUS_ID: 1,
            TITLE: "",
            USER_ID: 0,
            get_comments: [],
            get_status: {
                CODE: "",
                ID: null,
                NAME: ""
            }
        },
        loading: {
            ticket: false,
            comment: false
        }
    },

    mutations: {
        SET_TICKETS(state, payload) {
            state.tickets = payload
        },

        SET_TICKET(state, payload) {
            state.ticket = payload
        },

        SET_COMMENT(state, payload) {
            payload.B2B_USER_ID = Number(payload.B2B_USER_ID)
            state.ticket.get_comments.push(payload)
        },

        DELETE_COMMENT(state, payload) {
            state.ticket.get_comments = state.ticket.get_comments.filter(comment => payload[0] !== comment.ID)
        },

        SET_TICKET_STATUS(state, payload) {
            state.ticket.get_status = payload
        },

        UPDATE_TICKETS_STATUS(state, payload) {
            state.tickets = state.tickets.map(ticket => {
                if (state.ticket.ID === ticket.ID) {
                    ticket.STATUS_ID = payload.ID
                }
                return ticket
            })
        },

        ADD_TICKETS(state, payload) {
            state.tickets.unshift(payload)
        },

        DELETE_TICKET(state, id) {
            state.tickets = state.tickets.filter(ticket => id !== ticket.ID)
        },

        RESET_TICKETS(state) {
            state.tickets = []
        },

        RESET_TICKET(state) {
            state.ticket = {
                B2B_FEATURES: {},
                B2B_USER_ID: null,
                COMMENT: "",
                CREATED_AT: "",
                FILE: "",
                ID: null,
                PRIORITY_ID: 2,
                STATUS_ID: 1,
                TITLE: "",
                USER_ID: 0,
                get_comments: [],
                get_status: {
                    CODE: "",
                    ID: null,
                    NAME: ""
                }
            }
        },

        SET_LOADING(state, payload) {
            state.loading[payload.name] = payload.status
        },
    },

    actions: {
        fetchTickets({ commit }, userId) {
            commit("SET_LOADING", {
                name: 'ticket',
                status: true
            })
            this._vm.$api.ticket.getTasksByUserID(userId).then(( data ) => {
                if (!!data === false) { return false }
                commit("SET_TICKETS", data)
            })
            .finally(() => {
                commit("SET_LOADING", {
                    name: 'ticket',
                    status: false
                })
            })
        },

        fetchTicket({ dispatch, commit, getters }, taskId) {
            if (!getters.ticket.ID) {
                commit("SET_LOADING", {
                    name: 'ticket',
                    status: true
                })
            }

            this._vm.$api.ticket.getTaskById(taskId).then(( data ) => {
                commit('SET_TICKET', data)
                commit("SET_LOADING", {
                    name: 'ticket',
                    status: false
                })

            })
        },

        setStatusTicket({ state, commit, getters }, statusId) {
            commit("SET_LOADING", {
                name: 'ticket',
                status: true
            })
            this._vm.$api.ticket.updateStatusById({
                statusId: statusId,
                taskId: getters.ticket.ID
            }).then(( data ) => {
                commit('SET_TICKET_STATUS', data)
                commit("SET_LOADING", {
                    name: 'ticket',
                    status: false
                })
                commit('UPDATE_TICKETS_STATUS', data)
            })
        },

        deleteTicket({ commit }, taskId) {
            commit("DELETE_TICKET", taskId)
            commit("RESET_TICKET")
            this._vm.$api.ticket.deleteTask(taskId)
        },

        createComment({ commit, getters, rootGetters }, comment) {
            commit("SET_LOADING", {
                name: 'comment',
                status: true
            })
            this._vm.$api.ticket.createComment({
                userId: rootGetters['auth/currentUser'].id,
                taskId: getters.ticket.ID,
                comment: comment,
                userName: rootGetters['auth/currentUser'].name
            }).then(( data ) => {
                commit('SET_COMMENT', data)
                commit("SET_LOADING", {
                    name: 'comment',
                    status: false
                })
            })
        },

        deleteComment({ commit }, commentId) {
            commit('DELETE_COMMENT', commentId)
            this._vm.$api.ticket.deleteComment(commentId)
        },

        postTicket({ commit }, form ) {
            commit("SET_LOADING", {
                name: 'ticket',
                status: true
            })

            this._vm.$api.ticket.createTask(form)
                .then(( data ) => {
                    commit('ADD_TICKETS', data)
                    commit("SET_LOADING", {
                        name: 'ticket',
                        status: false
                    })
                })
        },

        getAllTickets({ commit } ) {
            commit("SET_LOADING", {
                name: 'ticket',
                status: true
            })
            this._vm.$api.ticket.getAllTasks().then(( data ) => {
                if (!!data === false) { return false }
                commit("SET_TICKETS", data)
            })
            .finally(() => {
                commit("SET_LOADING", {
                    name: 'ticket',
                    status: false
                })
            })
        }
    },

    getters: {
        loading : state => state.loading,
        tickets : state => state.tickets,
        ticket : state => state.ticket,
        ticketOpen : state => !!state.ticket.ID,
    },
}

export default {
    ...tickets
}
